import { FC } from 'react';

import { Text, TextProps } from '@chakra-ui/react';

const GalleryPeriodTitle: FC<TextProps> = ({ ...textProps }) => (
    <Text fontSize="l" fontWeight="200" ml={2} {...textProps} />
);

export default GalleryPeriodTitle;
